import React from "react";
import { Box } from "@mui/material";

const HipPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Hip"}
    </Box>
  );
};

export default HipPage;
